/* eslint-disable */
import { ActionIcon, Drawer, Tooltip } from "@mantine/core";
import { IconMessage } from "@tabler/icons-react";
import { useState } from "react";
import SupportForm from "./supportform";
import { PermissionActionIcon } from "api/permission/permissionActionBtn";

export default function SupportFloatingButton() {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Tooltip
        label="Contact support team"
        withArrow
        position="left"
        openDelay={100}
        closeDelay={100}
      >
        <PermissionActionIcon
          permission="ticket.view"
          // permission="employees.leaveConfiguration"
          variant="filled"
          color="blue"
          size="xl"
          radius="xl"
          onClick={() => setOpened(true)}
          aria-label="Open support form"
          style={{
            position: "fixed",
            bottom: 30,
            right: 30,
            zIndex: 9999,
          }}
          // title={`Edit ${leave.name}`}
        >
          <IconMessage size={28} />
        </PermissionActionIcon>
        {/* <ActionIcon
          variant="filled"
          color="blue"
          size="xl"
          radius="xl"
          onClick={() => setOpened(true)}
          aria-label="Open support form"
          style={{
            position: "fixed",
            bottom: 30,
            right: 30,
            zIndex: 9999,
          }}
        >
          <IconMessage size={28} />
        </ActionIcon> */}
      </Tooltip>

      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title={
          <div style={{ fontSize: "22px", fontWeight: 600 }}>
            Submit Support Ticket
          </div>
        }
        position="right"
        padding="lg"
        size="35%"
      >
        <SupportForm onSuccess={() => setOpened(false)} />
      </Drawer>
    </>
  );
}
